/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   selectors.ts
 */

import { createSelector } from '@reduxjs/toolkit'
import type { State } from '@zcode/state-type'
import { ROOT_STATE_KEY } from '../constants'

const selectCustomMessageRoot = (state: State) => state[ROOT_STATE_KEY]

export const selectCustomMessageChecked = createSelector(
  selectCustomMessageRoot,
  (state) => state.customMessageChecked
)

export const selectCustomMessageHasBeenChecked = createSelector(
  selectCustomMessageRoot,
  (state) => state.customMessageHasBeenChecked
)
